var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZenon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 77,
    viewBox: "0 0 48 77",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9838 6.10352e-05H0V9.43394H30.8722L0 28.627V29.9282V39.2971V77.0001H8.36965V52.8623L39.4685 77.0001H48V71.356V29.9282H15.7518L47.9838 9.30382V6.10352e-05ZM39.4685 39.2971L39.4847 64.4595L8.36965 39.3296V39.2971H39.4685Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24,
    y1: 0.0000610352,
    x2: 24,
    y2: 77.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6FF34D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BD926",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenon);
export default __webpack_public_path__ + "static/media/zenon.2b3fbdaff16345272e117ac1af27c2d8.svg";
export { ForwardRef as ReactComponent };